import { useEffect, useState } from 'react';

import { Card } from '../base/Card';
import { SectionLoading } from '../shared/SectionLoading';
import useAppliances from '../../data/appliance/useAppliances';
import { IPlanetDeviceWithFingotiDevice } from '../../types/PlanetDevice/PlanetDevice';
import usePlanetDevicesWithFingotiDevice from '../../data/planetDevice/usePlanetDevicesWithFingotiDevice';

export function Devices() {
  const { planetDevicesWithFingotiDevice } =
    usePlanetDevicesWithFingotiDevice();
  const { appliances } = useAppliances();
  const [deviceHardware, setDeviceHardware] = useState<
    IPlanetDeviceWithFingotiDevice[]
  >([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (
      !planetDevicesWithFingotiDevice.isLoading &&
      !appliances.isLoading &&
      planetDevicesWithFingotiDevice.data &&
      appliances.data
    ) {
      setDeviceHardware(
        planetDevicesWithFingotiDevice.data.filter((device) =>
          appliances.data.some((appliance) => appliance.deviceId === device.id)
        )
      );

      setLoading(false);
    }
  }, [
    planetDevicesWithFingotiDevice.isLoading,
    appliances.isLoading,
    planetDevicesWithFingotiDevice.data,
    appliances.data,
  ]);

  return (
    <Card title="Devices">
      {loading ? (
        <SectionLoading />
      ) : (
        <div className="mt-4">
          <div className="flex flex-row space-x-3">
            <div className="text-6xl font-light tracking-widest">
              {
                deviceHardware.filter(
                  (dev) => dev.gateway.device.cloud.connected
                ).length
              }
              /{deviceHardware.length}
            </div>
            <div className="flex items-end text-xl font-light">
              Devices Online
            </div>
          </div>
          <div className="mt-2 flex flex-row space-x-3">
            <div className="text-4xl font-light tracking-widest">
              {planetDevicesWithFingotiDevice!.data!.length -
                deviceHardware.length}
            </div>
            <div className="flex items-end text-xl font-light">
              Unassigned Atmo devices
            </div>
          </div>
        </div>
      )}
    </Card>
  );
}
